<div [formGroup]="formGroup()" class="inline-flex flex-col items-center gap-sm">
  <button
    type="button"
    [disabled]="disabled() || null"
    [attr.aria-pressed]="formGroup().get(inputFormControlName())?.value"
    [attr.aria-label]="label() || id()"
    (click)="onToggle()"
    class="inline-flex items-center justify-center w-6xl h-6xl rounded-md border-[1.5px] cursor-pointer transition-all duration-200 outline-none focus-visible:ring-2 focus-visible:ring-primary-500 focus-visible:ring-offset-2"
    [class.bg-primary-50]="isActive()"
    [class.text-primary-500]="isActive()"
    [class.border-transparent]="isActive()"
    [class.border-neutral-300]="!isActive()"
    [class.bg-white]="!isActive()"
    [class.text-neutral-700]="!isActive()"
    [class.opacity-40]="disabled()"
    [class.cursor-not-allowed]="disabled()"
    [class.pointer-events-none]="disabled()">
    <span>
      <ng-content></ng-content>
    </span>
  </button>

  <span class="text-xs2 font-medium text-neutral-500 whitespace-nowrap">
    {{ label() }}
  </span>
</div>
